module.exports = __webpack_public_path__ + "images/FUSA_icons/029-invoice-3.337dde938d044a875c84b0ea930d283f.svg";